import { css } from '@emotion/css';

export const inputClasses = css`
  &.MuiInputBase-root {
    min-height: 2.2rem;
    border-radius: 0rem;
    input {
      padding: 0 !important;
    }
  }
`;

export const textAlignCetnerInput = css`
  &.MuiInputBase-root {
    input {
      text-align: center;
    }
  }
`;
